import { Inject, Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { EnvironmentDto } from '../../app/api';
import { clientVersion } from 'src/environments/client-version';

export const BASE_URL = new InjectionToken<string>('BaseUrl');

@Injectable({
  providedIn: 'root'
})
export class CerSessionEnvironmentService {
  
  public primaryColor$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public title$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public licenseIssuedTo$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public name$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public appVersion$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public clientVersion$: BehaviorSubject<string> = new BehaviorSubject<string>(clientVersion);
  public clientNeedsReload$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public sessionIdleMinutes$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public sessionKeepaliveMinutes$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public documentationLibraryId$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  
  constructor(@Inject(BASE_URL) public baseUrl: string) {
  }

  public onEnvironment(environment : EnvironmentDto) {
    var e: EnvironmentDto = environment;
    if (e) {
      if (e.title != this.title$.getValue()) {
        this.title$.next(e.title);
      }

      if (e.licenseIssuedTo != this.licenseIssuedTo$.getValue()) {
        this.licenseIssuedTo$.next(e.licenseIssuedTo);
      }
      
      if (e.name != this.name$.getValue()) {
        this.name$.next(e.name);
      }

      if (e.version != this.appVersion$.getValue()) {
        this.onAppVersion(e.version);
      }

      if (e.primaryColor != this.primaryColor$.getValue()) {
        this.primaryColor$.next(e.primaryColor);
      }

      if (e.sessionIdleMinutes != this.sessionIdleMinutes$.getValue()) {
        this.sessionIdleMinutes$.next(e.sessionIdleMinutes);
      }

      if (e.sessionKeepaliveMinutes != this.sessionKeepaliveMinutes$.getValue()) {
        this.sessionKeepaliveMinutes$.next(e.sessionKeepaliveMinutes);
      }

      if (e.documentationLibraryId != this.documentationLibraryId$.getValue()) {
        this.documentationLibraryId$.next(e.documentationLibraryId);
      }
    }
  }

  public onAppVersion(appVersion: string) {
      this.appVersion$.next(appVersion);
      this.clientVersionCheck(appVersion, this.clientVersion$.getValue());
  }
  
  public title(): string {
    return this.title$.getValue();
  }

  public clientVersionCheck( appVersion: string, clientVersion: string) {
    if /*e.versionReload > 0)*/
       (appVersion?.length > 0 && appVersion != '1.0.0.0' &&
        clientVersion?.length > 0 && appVersion != clientVersion) {
      console.log(clientVersion + " <> " + appVersion);
      this.appVersion$.next(appVersion);
      this.clientNeedsReload$.next(true);
    }
  }
  
}
